import { defineFcm } from '../shared/factory';

export const FCM_AMPLITUDE_EXPERIMENTS_ENABLED = defineFcm('amplitude_experiments_enabled')
	.asBoolean()
	.withDefault(true)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-middle-end',
		context: 'Experiments (Amplitude)',
		description: `Global integration-health switch for Amplitude-backed experiments.

	When false, the middle-end forces every \`type: 'amplitude'\` experiment to its control variation
	(and typed fallback config), with no per-experiment change or deploy. It also stops each pod from
	talking to Amplitude at all: an already-running pod's local-evaluation client is paused (a
	dedicated timer re-checks this flag independently of the SDK's own poller/stream and calls
	stop()/start() to match), and a cold-booting pod skips its first connection attempt entirely.
	Defaults to true.

	This is an escape hatch for when the Amplitude SDK itself destabilizes pods, or when Amplitude
	needs to be cut off entirely (incident response, vendor-access removal) — NOT a clean way to
	pause a single experiment. To pause one experiment with correct bucketing/exposure semantics, stop
	it in the Amplitude Experiment dashboard instead. Exposure is deliberately not suppressed while this
	is off; exclude the disabled window in analysis instead.`,
		import: false,
		deprecated: 'Amplitude experiments removed from Corgi — no longer referenced; safe to delete after 2026-09-02.',
	});
